import { PlusOutlined } from '@ant-design/icons';
import {
    addClassRoomsDevices,
    applySingleProfile
    // applyClassRoomsDevices
    ,
    deleteClassRooms,
    deleteClassRoomsDevices,
    getClassRooms,
    getClassRoomsDevices,
    getTagList,
    getUnselectDevices,
    putClassRooms
} from "@axios/api.account";
import { RootStoreModel } from "@redux/reducers";
import { getOrgsOptionsSelector, treeNode } from "@redux/selector";
import { BasicStateForListModel, DeviceTypes } from "@src/home/models";
import {
    Breadcrumb,
    Button,
    Cascader,
    Col,
    Empty,
    Form,
    FormInstance,
    Input,
    Modal,
    Pagination,
    Popconfirm,
    Row,
    Select,
    Space,
    Table,
    notification
} from "antd";
import React from "react";
import { connect } from "react-redux";
import { Link, NavLink, RouteComponentProps } from "react-router-dom";

import { Translation } from "react-i18next";

interface propsModel extends RouteComponentProps<any, any, any> {
    organizations: treeNode[],
}

interface stateModel extends BasicStateForListModel {
    search: string,
    isEdit: boolean,
    classModalVisible: boolean,
    showDevices: boolean,
    titleName: string,
    userType: string,
    devices: [],
    devicesIndex: number,
    devicesSize: number,
    devicesCount: number,
    devicesModalVisible: boolean,
    searchDeviceName: string,
    organizations: any[],
    organizationId: string,
    tags: any[],
    tagName: any,
    unSelectedDevices: [],
    selectedRowKeys: [],
    roomId: string,
    isApply: boolean,
    pageIndex2: number,
    pageSize2: number,
    totalCount2: number,
}

const mapStatetoProps = (state: RootStoreModel) => ({
    organizations: getOrgsOptionsSelector(state),
})

const { Column } = Table;

class ClassPage extends React.Component<propsModel, stateModel> {
    formRef = React.createRef<FormInstance>();
    constructor(props: propsModel) {
        super(props);
        this.state = {
            loading: false,
            data: [],
            columns: [],
            pageIndex: 1,
            pageSize: 20,
            totalCount: 0,
            search: "",
            isEdit: false,
            classModalVisible: false,
            showDevices: false,
            titleName: "",
            userType: "",
            devices: [],
            devicesIndex: 1,
            devicesSize: 20,
            devicesCount: 0,
            devicesModalVisible: false,
            searchDeviceName: "",
            organizations: this.props.organizations,
            organizationId: "",
            tags: [],
            tagName: "",
            unSelectedDevices: [],
            selectedRowKeys: [],
            roomId: "",
            isApply: true,
            pageIndex2: 1,
            pageSize2: 20,
            totalCount2: 0,
        };
        this.init();
    }

    init() {
        this.getData();
    }

    getData(index=this.state.pageIndex, size=this.state.pageSize, search=this.state.search) {
        this.setState({loading: true})
        getClassRooms({
            search: search, 
            pageIndex: index,
            pageSize: size
        }).then(
            (res) => {
                const { dataList, pageIndex, pageSize, totalCount } = res;
                this.setState({
                    data: dataList,
                    pageIndex: pageIndex,
                    pageSize: pageSize,
                    totalCount: totalCount
                })
                
            },
            () => { notification.error({message: <Translation>{t => {return t("获取数据失败")}}</Translation>}) }
        ).finally(
            () => { this.setState({loading: false}) }
        )
    }

    updateClass() {
        this.setState({loading: true})
        this.formRef.current?.validateFields().then(
            (res) => {
                const { roomId, className, status } = res;
                putClassRooms({id: roomId, name: className, status: status}).then(
                    () => {
                        this.getData();
                        notification.success({
                            message: <Translation>{t => {
                                return `${this.state.isEdit ? t("编辑班级") : t("添加班级")} [${className}] ${t("成功")}!`
                            }}</Translation>
                        });
                    },
                    () => { 
                        notification.error({
                            message: <Translation>{t => {
                                return `${this.state.isEdit ? t("编辑班级") : t("添加班级")} [${className}] ${t("失败")}!`
                            }}</Translation>
                        }) 
                    },
                ).finally(
                    () => { 
                        this.setState({
                            loading: false, 
                            isEdit: false, 
                            classModalVisible: false
                        });
                        this.formRef.current?.resetFields(); 
                    }
                )
            },
            () => { this.setState({loading: false}) }
        )
    }

    deleteClass(item: any) {
        deleteClassRooms(item.roomId).then(
            () => {
                this.getData();
                notification.success({message: <Translation>{t => {return `${t("删除班级")} [${item.className}] ${t("成功")}!`}}</Translation>});
            },
            () => { notification.error({message: <Translation>{t => {return `${t("删除班级")} [${item.className}] ${t("失败")}!`}}</Translation>}) },
        )
    }

    getDevicesData(roomId: string, userType=this.state.userType, index=this.state.pageIndex, size=this.state.pageSize) {
        this.setState({loading: true});
        const params = {
            roomId: roomId, 
            userType: userType, 
            search: this.state.search, 
            pageIndex: index, 
            pageSize: size
        };
        getClassRoomsDevices(roomId, params).then(
            (res) => {
                const { dataList, pageIndex, pageSize, totalCount } = res;
                this.setState({
                    devices: dataList,
                    devicesIndex: pageIndex,
                    devicesSize: pageSize,
                    devicesCount: totalCount
                })
            },
            () => { notification.error({message: <Translation>{t => {return t("获取数据失败")}}</Translation>}) }
        ).finally(
            () => { this.setState({loading: false}) }
        )
    }

    getUnselectedDevicesData(index=this.state.pageIndex2, size=this.state.pageSize2) {
        this.setState({loading: true});
        const params: any = {
            pageIndex: index,
            pageSize: size
        };
        if (this.state.organizationId) { params.organizationId = this.state.organizationId }
        if (this.state.searchDeviceName) { params.search = this.state.searchDeviceName }
        if (this.state.tagName) { params.tagValueIds = this.state.tagName }
        getUnselectDevices(this.state.roomId, params).then(
            (res) => {
                const { dataList, pageIndex, pageSize, totalCount } = res;
                this.setState({
                    unSelectedDevices: dataList,
                    pageIndex2: pageIndex,
                    pageSize2: pageSize,
                    totalCount2: totalCount
                })
            },
            () => { notification.error({message: <Translation>{t => {return t("获取数据失败")}}</Translation>}) }
        ).finally(
            () => { this.setState({loading: false}) }
        )
    }

    getTags(){
        getTagList().then(res => {
            const tags = res.map(({id, key, values}) => {
                return {
                    value: id,
                    label: key,
                    children: values.map((item: any) => ({
                        value: item.id,
                        label: item.value,
                    }))
                }
            });
            this.setState({tags});
        })
    }

    addDevices() {
        this.setState({loading: true})
        addClassRoomsDevices(
            this.state.roomId, 
            {deviceIds: this.state.selectedRowKeys, userType: this.state.userType}
        ).then(
            () => {
                this.getDevicesData(this.state.roomId, this.state.userType);
                notification.success({message: <Translation>{t => {return t("添加设备成功")}}</Translation>});
            },
            ()=>{ notification.error({message: <Translation>{t => {return t("添加设备失败")}}</Translation>}) }
        ).finally(
            () => { 
                this.setState({
                    loading: false, 
                    devicesModalVisible: false,
                    searchDeviceName: "",
                    organizationId: "",
                    tagName: "",
                    selectedRowKeys: []
                }) 
            }
        )
    }

    deleteDevice(id: string) {
        deleteClassRoomsDevices(this.state.roomId, {deviceIds: id}).then(
            () => {
                this.getDevicesData(this.state.roomId, this.state.userType);
                notification.success({message: <Translation>{t => {return t("删除设备成功")}}</Translation>});
            },
            () => { notification.error({message: <Translation>{t => {return t("删除设备失败")}}</Translation>}) },
        )
    }

    // save() {
    //     this.setState({loading: true});
    //     applyClassRoomsDevices(this.state.roomId).then(
    //         () => { notification.success({message: <Translation>{t => {return t("保存成功")}}</Translation>}); },
    //         () => { notification.error({message: <Translation>{t => {return t("保存失败")}}</Translation>}) },
    //     ).finally(
    //         () => { this.setState({loading: false}) }
    //     )
    // }

    onSelectChange = (selectedRowKeys: any) => {
        this.setState({selectedRowKeys});
    };

    // clickApply = () => {
    //     applyProfile().then(() => {
    //         this.setState({isApply: false});
    //         notification.success({message: <Translation>{t => {return t("应用配置成功")}}</Translation>});
    //         setTimeout(() => {
    //             this.setState({isApply: true});
    //         }, 1000*60);
    //     })
    // }

    clickApply = (item :any) => {
        applySingleProfile(item.roomId).then(() => {
            notification.success({message: <Translation>{t => {return t("应用配置成功")}}</Translation>});
        })
    }

    render() {
        const {
            loading, data, search, isEdit, classModalVisible, 
            pageIndex, pageSize, totalCount, showDevices, titleName,
            devices, devicesIndex, devicesSize, devicesCount, devicesModalVisible,
            searchDeviceName, organizations, organizationId, tags, 
            unSelectedDevices, selectedRowKeys, isApply, roomId, userType, pageIndex2, 
            pageSize2, totalCount2
        } = this.state;
        const rowSelection = {
            selectedRowKeys: selectedRowKeys,
            onChange: this.onSelectChange,
        };
        return (
            <Translation>{t => {
                return (
                    <>
                        <div>
                            <h5 className="breadcrumbTop py-2">
                                <Breadcrumb>
                                    <Breadcrumb.Item>{t("配置文件")}</Breadcrumb.Item>
                                    <Breadcrumb.Item>
                                        <a onClick={() => {
                                            this.setState({
                                                showDevices: false,
                                                titleName: "", 
                                                userType: "",
                                                devices: [],
                                                devicesIndex: 1,
                                                devicesSize: 20,
                                                devicesCount: 0,
                                                pageIndex: 1,
                                                pageIndex2: 1,
                                            });
                                            this.getData();
                                        }}>{t("班级")}</a>
                                    </Breadcrumb.Item>
                                    {titleName?.trim() ? <Breadcrumb.Item>{t(titleName)}</Breadcrumb.Item> : null}
                                </Breadcrumb>
                                <Row style={{padding: "32px 0 11px 0"}}>
                                    <Space>
                                        <img src="/images/classIcon.svg" alt="" />
                                        <span style={{display: "flex", fontSize: 22, fontWeight: 500, marginTop: -5}}>{t("班级")}</span>
                                    </Space>
                                </Row>
                            </h5>
                            <Row style={{ width: "100%" }}>
                                {!showDevices && (
                                    <>
                                        <div className="borderBox">
                                            <Row className="mb-3">
                                                <Col>
                                                    <span>{t("班级名称")}:</span>
                                                    <Input
                                                        style={{ width: "200px", marginLeft: 10 }}
                                                        placeholder={t("输入班级名称搜索")} 
                                                        value={search}
                                                        onChange={(e) => { this.setState({search: e.target.value}) }} 
                                                    />
                                                </Col>
                                                <Col offset={1}>
                                                    <Button type="primary" onClick={() => { this.getData(1, 20, search) }}>
                                                        {t("查询")}
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </div>
                                        <div className="borderBox">
                                            <Row style={{ width: "100%", marginBottom: 8 }}>
                                                <Col className="ms-auto">
                                                    <Button type="primary" ghost
                                                        onClick={() => {
                                                            this.setState({ classModalVisible: true });
                                                            this.formRef.current?.resetFields();
                                                        }}
                                                    ><PlusOutlined />{t("添加班级")}</Button>
                                                    {/* <Button 
                                                        type="primary" 
                                                        style={{marginLeft: "10px"}}
                                                        disabled={!isApply}
                                                        onClick={() => { this.clickApply() }}
                                                    >{t("应用班级配置")}</Button> */}
                                                </Col>
                                            </Row>
                                            <Table 
                                                dataSource={data} 
                                                rowKey="roomId" 
                                                pagination={false} 
                                                style={{ width: "100%" }}
                                                locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                                            >
                                                <Column title={t("班级名称")} key="className" dataIndex="className"></Column>
                                                <Column 
                                                    title={t("学生设备")} 
                                                    key="studentCount" 
                                                    dataIndex="studentCount"
                                                    render={(value, row: any, index) => {
                                                        return (
                                                            <NavLink to={{ pathname: `/home/classes/devices/${row.roomId}`, state: { row, userType: 'Student'} }} >{value}</NavLink>
                                                        )
                                                    }}
                                                ></Column>
                                                <Column 
                                                    title={t("教师设备")} 
                                                    key="teacherCount" 
                                                    dataIndex="teacherCount"
                                                    render={(value, row: any, index) => {
                                                        return (
                                                            <NavLink to={{ pathname: `/home/classes/devices/${row.roomId}`, state: { row, userType: 'Teacher'} }} >{value}</NavLink>
                                                        )
                                                    }}
                                                ></Column>
                                                <Column title={t("状态")} key="status" dataIndex="status"></Column>
                                                <Column title={t("操作")} key="roomId" dataIndex="roomId"
                                                    render={(v, row: any, index) => {
                                                        return (
                                                            <Space size={8}>
                                                                <Button 
                                                                    type="link" block
                                                                    onClick={() => { this.clickApply(row) }}
                                                                >{t("应用班级配置")}</Button>
                                                                <Button type="link" block onClick={() => {
                                                                    this.setState({ classModalVisible: true, isEdit: true });
                                                                    this.formRef.current?.setFieldsValue(row);
                                                                }}>{t("编辑")}
                                                                </Button>
                                                                <Popconfirm
                                                                    title={`${t("确认删除")}？`}
                                                                    onConfirm={() => { this.deleteClass(row) }}
                                                                    okText={t("确认")}
                                                                    cancelText={t("取消")}
                                                                >
                                                                    <Button type="link" block>{t("删除")}</Button>
                                                                </Popconfirm>
                                                            </Space>
                                                        )
                                                    }}
                                                ></Column>
                                            </Table>
                                            <Pagination
                                                style={{ textAlign: "right", marginTop: "20px" }}
                                                pageSize={pageSize}
                                                current={pageIndex}
                                                total={totalCount}
                                                showTotal={(total, range) => `${range[0]}-${range[1]} / ${total} ${t("条")}`}
                                                onChange={(page, pageSize) => { this.getData(page, pageSize, search) }}
                                                onShowSizeChange={(current, size) => { this.getData(current, size, search) }}
                                            ></Pagination>
                                        </div>
                                    </>
                                )}
                            </Row>
                        </div>
                        <Modal
                            confirmLoading={loading}
                            open={classModalVisible}
                            maskClosable={false}
                            destroyOnClose={true}
                            title={`${isEdit ? t("编辑班级") : t("添加班级")}`}
                            forceRender={true}
                            onOk={() => { this.updateClass() }}
                            onCancel={() => { this.setState({classModalVisible: false, isEdit: false}) }}
                            okText={t("确认")}
                            cancelText={t("取消")}
                        >
                            <Form
                                ref={this.formRef}
                                layout="vertical"
                                initialValues={{status: "Disabled"}}
                            >
                                <Form.Item label="班级ID" name="roomId" hidden={true}>
                                    <Input></Input>
                                </Form.Item>
                                <Form.Item label={t("班级名称")} name="className" rules={[{required: true}]}>
                                    <Input></Input>
                                </Form.Item>
                                <Form.Item label={t("状态")} name="status">
                                    <Select>
                                        <Select.Option value="Active">{t("启用")}</Select.Option>
                                        <Select.Option value="Disabled">{t("禁用")}</Select.Option>
                                    </Select>
                                </Form.Item>
                            </Form>
                        </Modal>
                        <Modal
                            maskClosable={false}
                            title={t("添加设备")}
                            destroyOnClose={true}
                            confirmLoading={loading}
                            open={devicesModalVisible}
                            width="900px"
                            onOk={() => { this.addDevices() }}
                            onCancel={() => { 
                                this.setState({
                                    loading: false, 
                                    devicesModalVisible: false,
                                    selectedRowKeys: []
                                }) 
                            }}
                            okText={t("确认")}
                            cancelText={t("取消")}
                        >
                            <Row style={{width:"100%"}} gutter={24}>
                                <Col span={6}>
                                    <Input 
                                        placeholder={t("设备名称、序列号")} 
                                        value={searchDeviceName} 
                                        onChange={e => this.setState({searchDeviceName: e.target.value})}
                                    ></Input> 
                                </Col>
                                <Col span={6}>
                                    <Cascader 
                                        placeholder={t("设备组")} 
                                        options={tags} 
                                        onChange={res => {
                                            this.setState({tagName: res.length > 0 ? res[1] : ""})
                                        }} 
                                    />
                                </Col>
                                <Col span={6}>
                                    <Button type="primary" onClick={()=>{ this.getUnselectedDevicesData(1) }}>{t("搜索")}</Button>  
                                </Col>
                                <Col span={24} style={{marginTop:16}}>
                                    <Table
                                        size="middle"
                                        loading={loading}
                                        dataSource={unSelectedDevices}
                                        pagination={false}
                                        rowKey={"id"}
                                        rowSelection={rowSelection}
                                        locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                                    >
                                        <Column
                                            key="deviceName"
                                            dataIndex="deviceName"
                                            title={t("设备名称")}
                                        ></Column>
                                        <Column
                                            key="serialNo"
                                            dataIndex="serialNo"
                                            title={t("序列号")}
                                        ></Column>
                                        <Column
                                            key="model"
                                            dataIndex="model"
                                            title={t("设备型号")}
                                        ></Column>
                                        <Column
                                            key="userName"
                                            dataIndex="userName"
                                            title={t("用户")}
                                        ></Column>
                                        <Column
                                            key="deviceType"
                                            dataIndex="deviceType"
                                            title={t("设备类型")}
                                            render={(v) => t(DeviceTypes[v])}
                                        ></Column>
                                        <Column
                                            key="deviceType"
                                            dataIndex="deviceType"
                                            title={t("平台")}
                                        ></Column>
                                        <Column
                                            key="osVersion"
                                            dataIndex="osVersion"
                                            title={t("系统")}
                                        ></Column>
                                        <Column
                                            key="status"
                                            dataIndex="status"
                                            title={t("状态")}
                                        ></Column>
                                    </Table>
                                    <Pagination
                                        style={{ textAlign: "right", marginTop: "20px" }}
                                        pageSize={pageSize2}
                                        current={pageIndex2}
                                        total={totalCount2}
                                        showTotal={(total, range) => `${range[0]}-${range[1]} / ${total} ${t("条")}`}
                                        onChange={(page, pageSize) => { this.getUnselectedDevicesData(page, pageSize) }}
                                        onShowSizeChange={(current, size) => { this.getUnselectedDevicesData(current, size) }}
                                    ></Pagination>
                                </Col>

                            </Row>
                        </Modal>
                    </>
                )
            }}</Translation>
        )
    }
}

export default connect(mapStatetoProps, {})(ClassPage)
